import axios from '@didi/dajax'
import jsonp from 'jsonp'
import { getAuthParams, login } from '@didi-pebble/plugin-sso-login'
import { paramsFormat, transferConfig, prefixUrl, env } from '@/utils'
import I18n from '@/i18n/locale'
import { Message } from '@didi-pebble/pebble-design-vue'
import { gtrAuthNotify } from '@/utils/gtr-auth'
import { useAppStore } from '@/store'
import { requestTrackStart, requestTrackEnd } from '@/utils/raven'

const NODE_ENV = process.env.NODE_ENV

const reqHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

// axios实例，设置默认参数
const ajaxInstance = axios.create({
  headers: reqHeaders,
})

// 请求前常规参数结构化
ajaxInstance.interceptors.request.use(config => {
  config = paramsFormat(config)
  config.reqRavenId = requestTrackStart(config)
  return config
})
// 请求后http状态码判断
ajaxInstance.interceptors.response.use(response => {
  if (response.status !== 200) {
    Message({
      showClose: true,
      message: response.statusText,
      type: 'error',
    })
  }
  requestTrackEnd(response)
  return response.data
})

export function adapterParams(mixParams) {
  const appStore = useAppStore()
  const activeMicroAppConfig = appStore.activeMicroAppConfig
  if (!activeMicroAppConfig) return mixParams
  const activeMicroName = activeMicroAppConfig?.name
  if (activeMicroName === 'b_finance_i18n') {
    const { username: operator } = env.get('userInfo') // get(store.state, 'auth.userInfo', {});
    // 如果是财务项目
    mixParams = {
      operator,
      ...mixParams,
    }
  }
  return mixParams
}
const getGtrNewLocale = (country, locale) => {
  if (!country || !locale) return ''
  const [lang] = locale.split('-')
  return `${lang}_${country}`
}
// 获取公参
export function initRequestParams() {
  return ({ url, params = {} }) => {
    const { country = '', timezone, locale } = env.get('userInfo') // get(store.state, 'auth.userInfo', {});
    // 根据apiKey获取是走 /common 还是 /gateway 。同时产出 api 参数
    const { transUrl, transParams } = transferConfig(url)
    // 获取api对应的 server api Host
    const domainUrl = prefixUrl(transUrl)
    const urlPath = window.location.href || ''
    // 组装公参
    const mixParams = adapterParams({
      country,
      timezone,
      locale,
      gtrNewLocale: getGtrNewLocale(country, locale),
      ...getAuthParams(),
      ...transParams,
      ...params,
      urlPath,
    })
    // 使用 URLSearchParams 来处理查询参数
    const query = new URLSearchParams(mixParams)
    // 拼接 URL 和查询字符串
    const fullURL = `${domainUrl}?${query.toString()}`
    return {
      fullURL,
      transParams,
      mixParams,
      domainUrl,
    }
  }
}

function request(method, { url, headers = reqHeaders, params = {}, config = {} }) {
  const getComParmas = initRequestParams()
  const { mixParams, domainUrl, transParams } = getComParmas({ url, params })
  const defaultConfig = {
    method,
    url: domainUrl,
    params: mixParams,
    needEncrypt: true,
    ...config,
  }
  if (headers) {
    if (NODE_ENV === 'development') {
      // 主要为了proxy代理
      // const userInfo = env.get('userInfo');
      defaultConfig.headers = {
        ...reqHeaders,
        ...headers,
        api: transParams.api,
        // todo 直链用
        // 'Didi-Header-Userinfo': JSON.stringify({
        //   id: userInfo.id,
        //   username: userInfo.username,
        //   usernameZh: userInfo.usernameZh,
        //   dept: userInfo.dept,
        //   status: userInfo.status,
        //   isLogin: userInfo.isLogin,
        // }),
      }
    } else {
      defaultConfig.headers = {
        ...reqHeaders,
        ...headers,
      }
    }
  }
  return new Promise((resolve, reject) => {
    ajaxInstance(defaultConfig)
      .then(data => {
        const { errno } = data
        if (errno === 10000) {
          login(data.data)
          return reject(data)
        }
        if (errno === 0 || errno === '0') {
          return resolve(data)
        }
        if (errno === 24000) {
          return resolve(data)
        }
        if (errno === 40003) {
          return resolve(data)
        }
        // todo 无权限逻辑优化
        if ([500004, 510007].includes(+errno)) {
          // 无权限逻辑
          gtrAuthNotify(data)
          return reject(data)
        }
        Message({
          showClose: false,
          message: data.errmsg || I18n.t('soda-m-i18n---查询到的数据有点小问题，请再试一次'),
          type: 'error',
        })
        reject(data)
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          reject(error)
          return
        }
        console.error('error', error)
        Message({
          showClose: false,
          message:
            error.errmsg ||
            I18n.t('soda-m-i18n---您当前的网络环境不太好，请更换至网络稳定的环境再次尝试'),
          type: 'error',
        })
        reject(error)
        requestTrackEnd(error, error?.message)
      })
  })
}

export const CancelToken = axios.CancelToken
export const isCancel = axios.isCancel
export default ['get', 'post', 'jsonp'].reduce((api, method) => {
  if (method === 'jsonp') {
    api[method] = jsonp.bind()
  } else {
    api[method] = request.bind(null, method)
  }
  return api
}, {})
